import { ToolCall } from "@cohesive/api-client";
import { Tool_E2bBash } from "./renderers/Tool_E2bBash";

type ToolDataRendererProps = {
  call: ToolCall;
};

export function ToolDataRenderer(props: ToolDataRendererProps) {
  switch (props.call.function.name) {
    case "Tool_E2b_Bash":
      return <Tool_E2bBash call={props.call} />;
    default:
      return null;
  }
}
